// Copyright (c) 2017 PlanGrid, Inc.

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PhotoViewer from './photo-viewer';
import UnsupportedViewer from './unsupported-viewer';

function getPhotoDriver(width, height, fileType) {
  if (fileType === 'jpg' && window.Math.abs((width / height) - 2) <= 0.01) {
    return UnsupportedViewer;
  }
  return PhotoViewer;
}

export default class PhotoViewerWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      originalWidth: 0,
      originalHeight: 0,
      imageLoaded: false,
    };
  }

  componentDidMount() {
    const texture = new Image();
    texture.src = this.props.filePath;
    texture.onload = () => this.setState({
      originalWidth: texture.width,
      originalHeight: texture.height,
      imageLoaded: true,
      texture,
    });
  }

  render() {
    if (!this.state.imageLoaded) {
      return (<this.props.loadingComponent />);
    }
    const { originalWidth, originalHeight } = this.state;
    const PhotoDriver = getPhotoDriver(originalWidth, originalHeight, this.props.fileType);
    return (
      <PhotoDriver {...this.state} {...this.props} />
    );
  }
}

PhotoViewerWrapper.propTypes = {
  fileType: PropTypes.string.isRequired,
  filePath: PropTypes.string.isRequired,
  onError: PropTypes.func,
  errorComponent: PropTypes.element,
  unsupportedComponent: PropTypes.func,
  loadingComponent: PropTypes.func.isRequired,
};

PhotoViewerWrapper.defaultProps = {
  onError: () => null,
  errorComponent: null,
  unsupportedComponent: null,
};



// WEBPACK FOOTER //
// ./src/components/FileViewer/drivers/photo-viewer-wrapper.jsx